import { render } from "./Salida.vue?vue&type=template&id=5c8eea8e"
import script from "./Salida.vue?vue&type=script&lang=js"
export * from "./Salida.vue?vue&type=script&lang=js"
script.render = render

export default script